import Input from "../../../../Core/Fields/Floating/Input";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch"
import SearchSelectBox from "../../../../utils/SearchSelectBox"

const Tab2 = ({ vendor_address }) => {

  console.log(vendor_address.currentAddress.address_title, "vendor_address23");

  return (
    <div
      className="row  m-0"
      style={{ padding: "8px", borderRadius: "5px" }}
    >
      <div className="col-12">

        <div className="tableLabel">
          <p className="mb-1" style={{ color: "#391F84", fontWeight: '500' }}>
            Supplier Address
          </p>
          <div style={{ width: '99.5%', borderBottom: '1px solid #caced3', marginBottom: '15px' }}></div>
        </div>
      </div>
      {/* <div className="col-md-4 mt-0" >
        <div className="mb-3">
          <SelectSearch
            list={vendor_address.vendor_address_list}
            label="Select Supplier Address"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item}
            value={vendor_address.currentAddress.address_title}
            onChange={(val) => vendor_address.setselect_vendor_address(val)}
          />
        </div>
      </div> */}


       <div className="col-md-4 mt-0 mb-2" >
              <Input id="termsandconditions" label="Address 1" readOnly value={vendor_address.currentAddress?.address_line1} style={{ height: '30px' }} />
            </div>


      
      <div className="col-md-4 mt-0 mb-2" >
        <Input id="termsandconditions" label="Address 2" readOnly value={vendor_address.currentAddress?.address_line2} style={{ height: '30px' }} />
      </div>

       <div className="col-md-4 mt-0 mb-2" >
        <Input id="termsandconditions" label="City" readOnly value={vendor_address.currentAddress?.city} style={{ height: '30px' }} />
      </div>



        <div className="col-md-4 mt-0 mb-2" >
        <Input id="termsandconditions" label="State" readOnly value={vendor_address.currentAddress?.state}  style={{ height: '30px' }} />
      </div>



      <div className="col-md-4 mt-0 mb-2" >
        <Input id="termsandconditions" label="Country" readOnly value={vendor_address.currentAddress?.country} style={{ height: '30px' }} />
      </div>



      <div className="col-md-4 mt-0 mb-2" >
        <Input id="termsandconditions" label="Pincode" readOnly value={vendor_address.currentAddress?.pincode} style={{ height: '30px' }} />
      </div>



        <div className="col-md-4 mt-0 mb-2" >
        <Input id="termsandconditions" label="Supplier Contact" readOnly value={vendor_address.currentAddress?.phone} style={{ height: '30px' }} />
      </div>
      <div className="col-12 mt-3">
        <div className="tableLabel">
          <p className="mb-1" style={{ color: "#391F84", fontWeight: '500' }}>
            Shipping Address
          </p>
          <div style={{ width: '99.5%', borderBottom: '1px solid #caced3', marginBottom: '15px' }}></div>
        </div>
      </div>
      <div className="col-md-4 mt-0" >
        <div className="mb-3 " >
          <div className="form-floating">
            <input type="text" className="form-control p-0 px-2" style={{ fontSize: '0.8rem', height: '30px' }} id="supplieraddressdetails" placeholder="PUR-ORD-YYYY-" />
            <label htmlFor="supplieraddressdetails" style={{ fontSize: '0.8rem', color: "#212529a6" }}>Shipping Address</label>
          </div>
        </div>
      </div>

    </div>
  )
}

export default Tab2